import { useState, useRef, useCallback } from 'react';

function useToggle(initialValue, options) {
  const [state, setState] = useState(initialValue);
  const optionsRef = useRef(options);
  optionsRef.current = options;
  const toggle = useCallback((value) => {
    if (typeof value !== "undefined") {
      setState(value);
    } else {
      setState((current) => {
        if (current === optionsRef.current[0]) {
          return optionsRef.current[1];
        }
        return optionsRef.current[0];
      });
    }
  }, []);
  return [state, toggle];
}

export { useToggle };
//# sourceMappingURL=useToggle.mjs.map
